<!-- 首页导航 -->
<template>
  <div class='home-menu'>
    <div>
      <img :src='logo'
           alt="再来人Logo"
           calss="logo"
           width="160px"
           @click="logoHandle">
      <ul class="home-menu-list">
        <li v-if="mentorType">
          <a class="home-menu-metee-hover"> {{mentorType | mentorTypeTitle}}
            <div class="home-menu-metee">
              <span @click="menteeLinkHandle(item)"
                    v-for="(item,index) in mentorList"
                    :key="index">{{item.menteeEnName}}</span>
            </div>
          </a>
        </li>
        <li>
          <router-link to="/materials">Materials</router-link>
        </li>
        <li v-if="mentorType">
          <router-link to="/timesheet-penalty">Timesheet/Penalty</router-link>
        </li>
        <li v-if="mentorType && ['SM', 'EM'].includes(userRole)">
          <router-link to="/priority">Editing Priority</router-link>
        </li>
      </ul>
      <div class="home-menu-right">
        <div class="home-menu-remind">
          <zlr-remind></zlr-remind>
        </div>
        <div class="home-menu-avator">
          <zlr-personal></zlr-personal>
          <!-- <img :src="logo"
               alt=""> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { getUserRole } from '@/api/talents'
import { getMenteesList } from '@/api/joint'
// images
import logo from '@/assets/Logo.svg'
// components
import ZlrRemind from '_c/remind/remind'
import ZlrPersonal from '_c/dropdown/dropdown'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'home-menu',
  components: {
    ZlrRemind,
    ZlrPersonal
  },
  data () {
    return {
      logo,
      menuList: [
        {
          title: 'School Mentor',
          path: '/application'
        },
        {
          title: 'Edit Mentor',
          path: '/team'
        },
        {
          title: 'Career Mentor',
          path: '/mentor'
        }
      ],
      mentorType: '',
      mentorList: []
    }
  },
  computed: {
    ...mapState({
      'isPaymentInfo' (state) {
        return state.user.isPaymentInfo
      },
      'userRole' (state) {
        return state.user.userRole
      }
    })
  },
  mounted () {
    this.getUserRole()
  },
  methods: {
    ...mapMutations(['setUserRole', 'setMenteeList']),
    // 获取导师角色
    getUserRole () {
      getUserRole().then(res => {
        let mentorRole = res.data.userInfo.mentorRole
        this.mentorType = mentorRole
        if (mentorRole) {
          this.setUserRole(mentorRole)
          this.getMenteeList()
        }
      })
    },
    // 获取学生列表
    getMenteeList () {
      getMenteesList().then(res => {
        this.mentorList = res.data.model
        this.setMenteeList(res.data.model)
      })
    },
    logoHandle () {
      if (this.isPaymentInfo) {
        this.$router.push({
          name: 'home'
        })
      } else {
        this.$router.push({
          name: 'apply-banner'
        })
      }
    },
    menteeLinkHandle ({ menteeNum }) {
      this.$router.push({
        name: 'mentee-main',
        params: {
          id: menteeNum
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
